export default "__VITE_ASSET__BGbTSY4O__"